import React from "react";
import { useApp } from "../../context/AppProvider";

import Modal from "./Modal";
import ItemBalancete from "../ItemBalancete";

// Imports reais dos arquivos PDF
//import maio2025 from "../../assets/balancetes/balancete-maio-2025.pdf";
import agosto2026 from "../../assets/balancetes/balancete-agosto-2026.pdf";

// Mapeamento de identificadores para arquivos
const arquivosBalancetes = {
  //maio2025,
  agosto2026
};

// Lista com os identificadores
const listaBalancetes = [
//{
   // path: "maio2025",
    //title: "Maio 2025"
  //},
  {
    path: "agosto2026",
    title: "Agosto 2026"
  }
];

// Relatórios com URLs diretas
const listaRelAnual = [
  {
    path: "https://public.mobi2buy.com/noiz/relatorioanual.pdf",
    title: "Relatório Anual 2023"
  }
];

const Balancetes = () => {
  const { balancetes, setBalancetes } = useApp();

  return (
    <Modal visibility={balancetes} setVisibility={setBalancetes} id="balancetes">
      <h3>Transparência</h3>
      <div className="modal-area">
        <p>Confira mensalmente nosso balancete</p>

        <ul>
          {listaBalancetes.map((balancete) => (
            <ItemBalancete
              key={balancete.title}
              path={arquivosBalancetes[balancete.path]} // resolve o import
              title={balancete.title}
            />
          ))}
        </ul>

        <ul>
          {listaRelAnual.map((relanual) => (
            <ItemBalancete
              key={relanual.title}
              path={relanual.path}
              title={relanual.title}
            />
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default Balancetes;
